import React, { useMemo, useEffect } from "react";
import { ThemeProvider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getTheme } from "./theme";

const ThemeWrapper = ({ children }) => {
  const { i18n } = useTranslation();

  const theme = useMemo(() => {
    const direction = i18n.dir();
    return getTheme(direction);
  }, [i18n]);

  useEffect(() => {
    const dir = i18n.dir();
    document.body.dir = dir;
    document.documentElement.dir = dir;
  }, [i18n, i18n.language]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeWrapper;
